import { render, staticRenderFns } from "./CarpoolServiceItem.vue?vue&type=template&id=bec73ef2&"
import script from "./CarpoolServiceItem.vue?vue&type=script&lang=ts&"
export * from "./CarpoolServiceItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports